import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import CONTENT_CONTROLLER from '../../controllers/content';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import GlobalFilterPanel, { FILTER_PERIOD_GROUP } from '../filter/GlobalFilterPanel';
import { FeatureFlagEnum } from '../../utils/enums';

const log = new Logger('CLOSED_RETURNS_FILTERPANEL', LOG_LEVELS.DEBUG);

export class ClosedReturnsFilterPanel extends React.Component {

  constructor(props) {
    super(props);
    this.selectionHandler = this.selectionHandler.bind(this);
    this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    this.state = {
      countries: props.countryList, 
      allCountries: props.countryList,
      selection: {}
    };
  }

  onSearchClickHandler(selection) {
    log.debug('onSearchClickHandler(): state.selection: ', this.state.selection);
    log.debug('onSearchClickHandler(): selection: ', selection);
    let combinedSelection = Object.assign({}, this.state.selection, selection);
    log.debug('onSearchClickHandler(): combinedSelection: ', combinedSelection);
    this.props.onSearchClick(combinedSelection);
  }

  selectionHandler(keyValuePairs) {
    log.debug('filterSelectionHandler() Key value pairs: ', keyValuePairs);    
    let key =  Object.keys(keyValuePairs)[0];
    let value =  Object.values(keyValuePairs)[0];
    let selection = Object.assign({}, this.state.selection);
    if(_.isEmpty(value)) {
      delete selection[key];
    } else {
      selection = Object.assign(selection, keyValuePairs);
    }
    this.setState({
      selection: selection
    });
  }

  reportSelectionHandler(e) {
    const newValue = e.target.value;
    if(typeof this.selectionHandler === 'function') {
      this.selectionHandler({reportType: newValue});
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps.selectedCompanyIds !== this.props.selectedCompanyIds) {

      log.debug("componentWillReceiveProps(): selectedCompanyIds: %s is updated", nextProps.selectedCompanyIds);
      //If dont have enough details to perform filtering show all.
      if(!nextProps.selectedCompanyIds) {        
        this.setState({ countries: this.state.allCountries });
        return;
      }
      log.debug("componentWillReceiveProps(): filtering countries: ", nextProps.countryList);
      let allCountry = this.state.allCountries || [];          
      log.debug("componentWillReceiveProps(): allCountry : ", allCountry);
      if(!nextProps.selectedCompanyDetails.vatNumbers) {
        this.setState({ countries: [] });
        return;
      }
      let companyVatNumbers = nextProps.selectedCompanyDetails.vatNumbers;
      let countryCodesWithCompanyVAT = companyVatNumbers.map((vatDetails, index) => vatDetails.vatnumberCountry);
      log.debug("componentWillReceiveProps(): countryCodesWithCompanyVAT : ", countryCodesWithCompanyVAT);
      let countriesWithCompanyVatnumber = allCountry.filter((countryDetails, index) => {
        return countryCodesWithCompanyVAT.includes(countryDetails.countryCode);
      });
      log.debug("componentWillReceiveProps(): countriesWithCompanyVatnumber : ", countriesWithCompanyVatnumber);
      this.setState({ countries: countriesWithCompanyVatnumber });
    }
  }

  componentDidMount() {
    this.props.onPageLoad();
  }

  render() {
    log.debug('render(): ', this.props);
    const {selection = {}} =  this.state;
    const disableSearch = _.isEmpty(selection) || _.isEmpty(selection.countryCode);
    const returnTypes = ["VATReturn", "ECListing", "LocalListing", "Intrastat", "OSSUnion", "OSSNonUnion", "OSSImport"];

    if (this.props.featureFlags?.[FeatureFlagEnum.ENABLE_VIEW_AND_REOPEN_VATBOOK]) {
      returnTypes.push("VATBook");
    }
    return (
      <s-box name="filter-panel">
          <GlobalFilterPanel 
            countries={this.props.countryList}
            filterPeriodGroup={FILTER_PERIOD_GROUP.DATE_RANGE} 
            disableSearch={{disableSearch}} 
            hideElements={{
              month: true,
              year:true,
              returnStatus: true}}
            onSearchClick={this.onSearchClickHandler}
            applyLicencesCheck={false}
            filteredReturnTypes={returnTypes}
            companySelectValueLanguageStringKey="global_All"
            countrySelectValueLanguageStringKey="global_All"
          >
          </GlobalFilterPanel>
          <div className="clear"></div>
      </s-box>
    )
  }
}

export function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    featureFlags: state.featureFlag?.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onPageLoad: () => {
      dispatch(CONTENT_CONTROLLER.doLoad());
    }
  };
}


ClosedReturnsFilterPanel.defaultProps = {
  selectedCompanyIds: '',
  selectedCompanyDetails: {},
  onSearchClick: () => {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ClosedReturnsFilterPanel);